module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "Top_Panel"
  }, [_c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row PageTitle"
  }, [_c('div', {
    staticClass: "col-md-2"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('br'), _vm._v(" "), _c('h8', [_vm._v("Pair'd")])], 1), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('b-button', {
    staticClass: "GetStartedButton hvr-grow",
    attrs: {
      "size": "lg",
      "variant": "primary",
      "href": ""
    }
  }, [_vm._v("\n        Get Started\n    ")])], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2"
  }, [_c('img', {
    attrs: {
      "src": require("./../assets/MainPage_Pearlogo.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-1"
  }, [_c('img', {
    attrs: {
      "src": require("./../assets/MainPage_Pearlogo.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "PageSubtitle"
  }, [_vm._v("Find Your Mentor Today")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0669d0f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main.vue
// module id = 37
// module chunks = 0